import store from "../stories/store";
import { setDirectHistory } from "../stories/actions";

export const appendNewMesageDirectHistory = async (data) => {
    const { sameAuthor, receiverSocketId, authorSocketId } = data;

    if (sameAuthor) {
        await appendNewMesageHistory(receiverSocketId, data);
    } else {
        await appendNewMesageHistory(authorSocketId, data);
    }
};

const appendNewMesageHistory = async (roomSocketId, data) => {
    const messageHistory = [...store.getState().directHistory];
    const userMessageHistory = messageHistory.find((history) => history.roomSocketId === roomSocketId);

    if (userMessageHistory) {
        const newDirectMessage = {
            sameAuthor: data.sameAuthor,
            username: data.username,
            content: data.content,
        };

        const newUserMessageHistory = {
            ...userMessageHistory,
            messageHistory: [...userMessageHistory.messageHistory, newDirectMessage],
        };

        const newMessageHistory = [
            ...messageHistory.filter((history) => history.roomSocketId !== roomSocketId),
            newUserMessageHistory,
        ];

        store.dispatch(setDirectHistory(newMessageHistory));
    } else {
        const newUserMessageHistory = {
            roomSocketId: roomSocketId,
            messageHistory: [
                {
                    sameAuthor: data.sameAuthor,
                    username: data.username,
                    content: data.content,
                },
            ],
        };

        const newMessageHistory = [...messageHistory, newUserMessageHistory];

        store.dispatch(setDirectHistory(newMessageHistory));
    }
};